export default "__VITE_ASSET__CHA_bjCX__"